module.exports = __webpack_public_path__ + "static/Ipad3-b0d105613b37242aee99293788762592.png";